exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".overlay[data-v-03b0096d]{position:fixed;bottom:0;left:0;right:0;height:0;width:100%;height:100%;z-index:10;-webkit-transition:opacity .3s;transition:opacity .3s;opacity:1}.overlay .inner[data-v-03b0096d]{position:absolute;bottom:0;left:0;right:0;height:0;width:100%;height:100%;background-color:rgba(0,0,0,.6)}.overlay.transparent .inner[data-v-03b0096d]{background-color:transparent}.overlay.overlay-enter[data-v-03b0096d],.overlay.overlay-leave-active[data-v-03b0096d]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03b0096d","scoped":true,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/overlay/index.vue
// module id = ZcY/
// module chunks = 1